import {Axios} from '../axios/axios.js'
//获取列表
export const getAnalyze = (e) => {
  return Axios({
    url:"/index.php/Anylaze/get_anylaze_data",
    method:'put',
    data:e
  })
}
//下载 /anylaze/export_anylaze
export const exportAnylaze = (e) => {
  return Axios({
    url:"/index.php/Anylaze/export_anylaze",
    method:'put',
    data:e,
  })
}
